import { getWechatConfig, wechatAuth } from "@api/public";
import cookie from "@utils/store/cookie";
import store from "@/store";
import dayjs from "dayjs";
import { logger } from "@/utils/logger";

const STATE_KEY = "wx_authorize_state";
// 获取微信配置
export function getConfig() {
  return new Promise((resolve, reject) => {
    getWechatConfig()
      .then((res) => {
        if (res.success) {
          resolve(res.data);
        } else {
          reject(res);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
}

// 跳转微信code获取
export const toAuth = (appId, backUrl) => {
  logger.wechat("进入toAtuh");
  const redirect_uri = encodeURIComponent(
    `${location.origin}/auth/${encodeURIComponent(
      backUrl ? backUrl : location.pathname + location.search
    )}`
  );
  logger.wechat("获取到redirect_uri", redirect_uri);
  // cookie.remove(BACK_URL);
  const state = encodeURIComponent(
    ("" + Math.random()).split(".")[1] + "authorizestate"
  );
  logger.wechat("获取到state", state);
  logger.wechat("开始保存state", STATE_KEY, state);
  cookie.set(STATE_KEY, state);
  logger.wechat("保存state成功");
  logger.wechat(
    "开始跳转微信授权页面",
    `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`
  );
  location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`;
};

// 授权登录获取用户信息
export function auth(code) {
  return new Promise((resolve, reject) => {
    let loginType = null;
    // 添加日志
    // console.log("开始授权, code:", code);
    // console.log("spread:", cookie.get("spread"));
    logger.wechat("开始授权, code:", code);
    logger.wechat("spread:", cookie.get("spread"));
    logger.wechat("开始设置spread");
    const spread = parseInt(cookie.get("spread") || 0);
    logger.wechat("设置spread成功", spread);
    logger.wechat("wechat-handle:开始授权");
    wechatAuth(code, spread, loginType)
      .then(({ data }) => {
        // console.log("授权成功，返回数据:", data);
        logger.wechat("授权成功，返回数据:", data);
        const expires_time = dayjs(data.expires_time);
        const newTime = Math.round(new Date() / 1000);

        try {
          logger.wechat("开始设置token cookie", "login_status", data.token);
          cookie.set("login_status", data.token);
          logger.wechat("设置token cookie成功：", cookie.get("login_status"));
          logger.wechat(
            "开始设置store",
            "LOGIN",
            data.token,
            expires_time - newTime
          );
          store.commit("LOGIN", data.token, expires_time - newTime);
          logger.wechat("设置store成功");
          logger.wechat("开始删除cookie", STATE_KEY);
          cookie.remove(STATE_KEY);
          logger.wechat("删除cookie成功");
          loginType && cookie.remove("loginType");
          resolve();
        } catch (error) {
          logger.error("Cookie设置失败:", error);
          // console.error("Cookie设置失败:", error);
          reject(error);
        }
      })
      .catch((err) => {
        // console.error("授权失败详细信息:", err);
        logger.error("授权失败详细信息:", err);
        reject(err);
      });
  });
}
